module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content has-text-left",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('table', {
    staticClass: "table is-striped is-responsive",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "id": "cpa-commissions"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('datetime').tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('client').tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('commission_amount').tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('tier_name').tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('trades_completed').tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('volume_traded').tUpper()))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('status').tUpper()))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.CPACommissions), function(cpac, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(_vm.$formatDateTime(cpac.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$constructFullClientName(cpac.firstname, cpac.lastname, cpac.company_name)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$formatMoney(cpac.commission_amount, '$')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cpac.tier_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cpac.trades_completed) + " / " + _vm._s(cpac.trades_required))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cpac.volume_traded) + " / " + _vm._s(cpac.volume_required))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(cpac.status))])])
  }), 0)]), _vm._v(" "), _c('pagination', {
    ref: "cpaCommissions",
    attrs: {
      "for": "cpa-commissions",
      "records": _vm.pagination.totalRows,
      "per-page": _vm.pagination.rowsPerPage,
      "chunk": 4,
      "count-text": _vm.pagination.totalRows + ' ' + _vm.$t('records')
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39fe5660"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partner/CPACommissions.vue
// module id = 750
// module chunks = 0